import { useEffect } from "react";
import { Routes, Route, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { publicRoutes } from "./public";
import { MainLayout } from "../layouts/MainLayout";
import NotFound from "../pages/Misc/NotFound";
import { NON_DEFAULT_LANGUAGES } from "../utils/localePaths";

// Gates the /:lang/* route tree: 404s on an unsupported language segment,
// otherwise switches i18next to it before rendering the matched page.
function LocaleGate() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (NON_DEFAULT_LANGUAGES.includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  if (!NON_DEFAULT_LANGUAGES.includes(lang)) {
    return <NotFound />;
  }

  return <Outlet />;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Default, unprefixed (English) tree — unchanged. */}
      <Route element={<MainLayout />}>
        {publicRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Route>

      {/* Locale-prefixed tree, e.g. /es/*, /de/* — same route list, relativized. */}
      <Route path=":lang" element={<LocaleGate />}>
        <Route element={<MainLayout />}>
          {publicRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path === "/" ? "" : path.replace(/^\//, "")}
              element={<Component />}
            />
          ))}
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
